<style>
    .my-drop-zone { border: dotted 3px lightgray; }
    .nv-file-over { border: dotted 3px red; } /* Default class applied to drop zones on over */
    .another-file-over-class { border: dotted 3px green; }

    html, body { height: 100%; }
</style>


<c-card *transloco="let t">
    <c-card-body>

        <div style="margin-bottom: 20px">

            <h3>{{ t('Select files') }}</h3>

            <div ng2FileDrop
                 [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
                 (fileOver)="fileOverBase($event)"
                 [uploader]="uploader"
                 class="well my-drop-zone"
                 style="width:100%;height:200px;">
                {{ t('Drop your worker upload file here or select it using the button below') }}
            </div>
            <input type="file" ng2FileSelect [uploader]="uploader" />
        </div>

        <div style="margin-bottom: 20px">

            <h3>{{ t('Upload queue') }}</h3>
            <p>{{ t('Queue length') }}: {{ uploader?.queue?.length }}</p>

            <table class="table">
                <thead>
                <tr>
                    <th width="50%">{{ t('Name') }}</th>
                    <th>{{ t('Size') }}</th>
                    <th>{{ t('Progress') }}</th>
                    <th>{{ t('Status') }}</th>
                </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let item of uploader.queue">
                <tr>
                    <td><strong>{{ item?.file?.name }}</strong></td>
                    <td *ngIf="uploader.options.isHTML5" nowrap>{{ item?.file?.size/1024/1024 | number:'.2' }} MB</td>
                    <td *ngIf="uploader.options.isHTML5">
                        <div class="progress" style="margin-bottom: 0;">
                            <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': item.progress + '%' }"></div>
                        </div>
                    </td>
                    <td class="text-center">
                        <span *ngIf="item.isSuccess"><i class="glyphicon glyphicon-ok"></i></span>
                        <span *ngIf="item.isCancel"><i class="glyphicon glyphicon-ban-circle"></i></span>
                        <span *ngIf="item.isError"><i class="glyphicon glyphicon-remove"></i></span>
                    </td>
                </tr>
                <tr>
                    <td colspan="4">
                        <button type="button" class="btn btn-success btn-xs"
                                (click)="item.upload()" [disabled]="item.isReady || item.isUploading || item.isSuccess">
                            <span class="glyphicon glyphicon-upload"></span> {{ t('Upload') }}
                        </button>
                        <button type="button" class="btn btn-warning btn-xs"
                                (click)="item.cancel()" [disabled]="!item.isUploading">
                            <span class="glyphicon glyphicon-ban-circle"></span> {{ t('Cancel') }}
                        </button>
                        <button type="button" class="btn btn-danger btn-xs"
                                (click)="item.remove()">
                            <span class="glyphicon glyphicon-trash"></span> {{ t('Remove') }}
                        </button>
                    </td>
                </tr>
                </ng-container>
                </tbody>
            </table>

            <div>
                <div>
                    {{ t('Queue progress') }}:
                    <div class="progress" style="">
                        <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': uploader.progress + '%' }"></div>
                    </div>
                </div>
                <div class="alert alert-danger" role="alert"  *ngIf="file_error">
                  {{file_error}}
                </div>
            </div>

        </div>
    </c-card-body>
</c-card>
